module.exports = __webpack_public_path__ + "static/kv-large-be9f24fe3b61abed3a813e420b635962.png";